export class PlantZone {
    plantId:number;
    zoneId:number;

    constructor(plantId:number,zoneId:number){
        this.plantId = plantId;
        this.zoneId = zoneId;
    }
}